<mat-form-field>
    <input
        matInput
        [placeholder]="placeholder"
        [matAutocomplete]="auto"
        [formControl]="searchCtrl"
        (blur)="handleBlur($event)" />
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete">
    <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option"
        (onSelectionChange)="handleSelect($event)">
        {{ option.name }}
    </mat-option>
</mat-autocomplete>
<mat-chip-list *ngIf="selectedOptions?.length">
    <mat-chip color="primary" selected="true" *ngFor="let option of selectedOptions; let optionIndex = index;">
        <span>{{ option.name }}</span>
        <close-icon class="mat-remove" (click)="handleRemove(optionIndex)"></close-icon>
    </mat-chip>
</mat-chip-list>